module.exports = __webpack_public_path__ + "img/mc.5b037c6b.svg";